// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type PeopleAnalyticsQueryVariables = PrivateSchemaTypes.Exact<{
  filter: PrivateSchemaTypes.AnalyticsFilterWithGroups;
  chartTimeUnit: PrivateSchemaTypes.TimeUnitEnum;
}>;


export type PeopleAnalyticsQuery = (
  { __typename?: 'Query' }
  & { analytics: (
    { __typename?: 'AnalyticsModel' }
    & { resources: (
      { __typename?: 'AnalyticsResourcesModel' }
      & { totalViewsCountAllDevices: PrivateSchemaTypes.AnalyticsResourcesModel['totalViewsCount'], totalViewsCountMobile: PrivateSchemaTypes.AnalyticsResourcesModel['totalViewsCount'], totalViewsCountTablet: PrivateSchemaTypes.AnalyticsResourcesModel['totalViewsCount'] }
      & { topicViewsByHour?: PrivateSchemaTypes.Maybe<Array<(
        { __typename?: 'AnalyticsHitCountByHourModel' }
        & Pick<PrivateSchemaTypes.AnalyticsHitCountByHourModel, 'count' | 'hour'>
      )>>, topicViewsByTimeUnit: Array<(
        { __typename?: 'AnalyticsHitCountByTimeUnit' }
        & Pick<PrivateSchemaTypes.AnalyticsHitCountByTimeUnit, 'count' | 'day'>
      )> }
    ), people: (
      { __typename?: 'AnalyticsPeopleModel' }
      & Pick<PrivateSchemaTypes.AnalyticsPeopleModel, 'uniqueActiveUsersCount'>
      & { activeUsersByDay: Array<(
        { __typename?: 'AnalyticsHitCountByTimeUnit' }
        & Pick<PrivateSchemaTypes.AnalyticsHitCountByTimeUnit, 'count' | 'day'>
      )> }
    ) }
  ) }
);

export type PeopleOverviewTableQueryVariables = PrivateSchemaTypes.Exact<{
  mainAnalyticsFilter: PrivateSchemaTypes.AnalyticsFilterWithGroups;
  peopleOverviewFilter: PrivateSchemaTypes.AnalyticsPeopleFilter;
  activePeopleOverviewFilter: PrivateSchemaTypes.AnalyticsPeopleFilter;
  inactivePeopleOverviewFilter: PrivateSchemaTypes.AnalyticsPeopleFilter;
}>;


export type PeopleOverviewTableQuery = (
  { __typename?: 'Query' }
  & { analytics: (
    { __typename?: 'AnalyticsModel' }
    & { people: (
      { __typename?: 'AnalyticsPeopleModel' }
      & Pick<PrivateSchemaTypes.AnalyticsPeopleModel, 'usersOverviewCount'>
      & { activeUsersOverviewCount: PrivateSchemaTypes.AnalyticsPeopleModel['usersOverviewCount'], inactiveUsersOverviewCount: PrivateSchemaTypes.AnalyticsPeopleModel['usersOverviewCount'] }
      & { usersOverview: Array<(
        { __typename?: 'AnalyticsViewCountByUserModel' }
        & Pick<PrivateSchemaTypes.AnalyticsViewCountByUserModel, 'resourceViewsCount' | 'pathwayEnrolmentsCount' | 'attendedEventsCount' | 'workbooksCount' | 'surveysCount' | 'certificationEnrolmentsCount'>
        & { user: (
          { __typename?: 'UserModel' }
          & Pick<PrivateSchemaTypes.UserModel, 'display_name' | 'email' | 'image_url' | 'id' | 'last_activity_at' | 'deleted_at'>
        ) }
      )> }
    ) }
  ) }
);


export const PeopleAnalyticsDocument = gql`
    query PeopleAnalytics($filter: AnalyticsFilterWithGroups!, $chartTimeUnit: TimeUnitEnum!) {
  analytics(filter: $filter) {
    resources {
      totalViewsCountAllDevices: totalViewsCount
      totalViewsCountMobile: totalViewsCount(deviceType: MOBILE)
      totalViewsCountTablet: totalViewsCount(deviceType: TABLET)
      topicViewsByHour {
        count
        hour
      }
      topicViewsByTimeUnit(unit: $chartTimeUnit) {
        count
        day
      }
    }
    people {
      uniqueActiveUsersCount
      activeUsersByDay: activeUsersByTimeUnit(unit: $chartTimeUnit) {
        count
        day
      }
    }
  }
}
    `;

/**
 * __usePeopleAnalyticsQuery__
 *
 * To run a query within a React component, call `usePeopleAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeopleAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeopleAnalyticsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      chartTimeUnit: // value for 'chartTimeUnit'
 *   },
 * });
 */
export function usePeopleAnalyticsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PeopleAnalyticsQuery, PeopleAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PeopleAnalyticsQuery, PeopleAnalyticsQueryVariables>(PeopleAnalyticsDocument, options);
      }
export function usePeopleAnalyticsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PeopleAnalyticsQuery, PeopleAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PeopleAnalyticsQuery, PeopleAnalyticsQueryVariables>(PeopleAnalyticsDocument, options);
        }
export type PeopleAnalyticsQueryHookResult = ReturnType<typeof usePeopleAnalyticsQuery>;
export type PeopleAnalyticsLazyQueryHookResult = ReturnType<typeof usePeopleAnalyticsLazyQuery>;
export type PeopleAnalyticsQueryResult = Apollo.QueryResult<PeopleAnalyticsQuery, PeopleAnalyticsQueryVariables>;
export const PeopleOverviewTableDocument = gql`
    query PeopleOverviewTable($mainAnalyticsFilter: AnalyticsFilterWithGroups!, $peopleOverviewFilter: AnalyticsPeopleFilter!, $activePeopleOverviewFilter: AnalyticsPeopleFilter!, $inactivePeopleOverviewFilter: AnalyticsPeopleFilter!) {
  analytics(filter: $mainAnalyticsFilter) {
    people {
      usersOverview(overviewTableFilter: $peopleOverviewFilter) {
        user {
          display_name
          email
          image_url
          id
          last_activity_at
          deleted_at
        }
        resourceViewsCount
        pathwayEnrolmentsCount
        attendedEventsCount
        workbooksCount
        surveysCount
        certificationEnrolmentsCount
      }
      usersOverviewCount(overviewTableFilter: $peopleOverviewFilter)
      activeUsersOverviewCount: usersOverviewCount(
        overviewTableFilter: $activePeopleOverviewFilter
      )
      inactiveUsersOverviewCount: usersOverviewCount(
        overviewTableFilter: $inactivePeopleOverviewFilter
      )
    }
  }
}
    `;

/**
 * __usePeopleOverviewTableQuery__
 *
 * To run a query within a React component, call `usePeopleOverviewTableQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeopleOverviewTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeopleOverviewTableQuery({
 *   variables: {
 *      mainAnalyticsFilter: // value for 'mainAnalyticsFilter'
 *      peopleOverviewFilter: // value for 'peopleOverviewFilter'
 *      activePeopleOverviewFilter: // value for 'activePeopleOverviewFilter'
 *      inactivePeopleOverviewFilter: // value for 'inactivePeopleOverviewFilter'
 *   },
 * });
 */
export function usePeopleOverviewTableQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PeopleOverviewTableQuery, PeopleOverviewTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PeopleOverviewTableQuery, PeopleOverviewTableQueryVariables>(PeopleOverviewTableDocument, options);
      }
export function usePeopleOverviewTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PeopleOverviewTableQuery, PeopleOverviewTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PeopleOverviewTableQuery, PeopleOverviewTableQueryVariables>(PeopleOverviewTableDocument, options);
        }
export type PeopleOverviewTableQueryHookResult = ReturnType<typeof usePeopleOverviewTableQuery>;
export type PeopleOverviewTableLazyQueryHookResult = ReturnType<typeof usePeopleOverviewTableLazyQuery>;
export type PeopleOverviewTableQueryResult = Apollo.QueryResult<PeopleOverviewTableQuery, PeopleOverviewTableQueryVariables>;